import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { filterBy, process } from "@progress/kendo-data-query";
import { Window } from "@progress/kendo-react-dialogs";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { Popup } from "@progress/kendo-react-popup";
import * as moment from "moment";
import React, { useEffect,  useState } from "react";
import { toastr } from "react-redux-toastr";
import { NavLink, useHistory } from "react-router-dom";
import * as XLSX from "xlsx";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/RiskDashboard.scss";
import ColumnMenuFilter from "../Dashboard/ColumnMenuFilter";
import { CustomFieldSearchMenu } from "../Dashboard/CustomFieldSearchMenu";
import GridExpandComponent from "./Component/GridExpandCompoent";
import RiskColumns from "./RiskColumns.json";
import PersistenceTasks from "./PersistenceTasks.json";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import { formatNumber } from "@telerik/kendo-intl";
import { useRef } from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import {Errorlogtreeview,TreeItem} from "./Component/Errorlogtreeview"
import TaskTitle from "../Tasks/TaskTitle";
import TaskApproved from "../Tasks/TaskApproved";
import TaskDescription from "../Tasks/TaskDescription";
import TaskCost from "../Tasks/TaskCost";
import TaskEffort from "../Tasks/TaskEffort";
import TaskPercentageOnTrack from "../Tasks/TaskPercentageOnTrack";
import TaskPercentageCompletion from "../Tasks/TaskPercentageCompletion";
import TaskOriginalCompDate from "../Tasks/TaskOriginalCompDate";
import TaskProjectedComDate from "../Tasks/TaskProjectedComDate";
import TaskActualCompDate from "../Tasks/TaskActualCompDate";
import TaskProximityAlertDate from "../Tasks/TaskProximityAlertDate";
import TaskDelayConsequence from "../Tasks/TaskDelayConsequence";
import TaskAlertStakeholders from "../Tasks/TaskAlertStakeholders";
import TaskAlertDescription from "../Tasks/TaskAlertDescription";
import TaskOwner from "../Tasks/TaskOwner";
import TaskStatus from "../Tasks/TaskStatus";
import TaskCustomFieldMultiDropdown from "../Tasks/TaskCustomFieldMultiDropdown";
import TaskCustomFieldSingleDropdown from "../Tasks/TaskCustomFieldSingleDropdown";
import TaskCustomFieldFreeText from "../Tasks/TaskCustomFieldFreeText";
import TaskCustomFieldNumber from "../Tasks/TaskCustomFieldNumber";
import TaskCustomFieldDate from "../Tasks/TaskCustomFieldDate";
import { TaskActionExpandGrid } from "../Tasks/TaskActionExpandGrid";
import TaskRegisterFormView from "../Tasks/TaskRegisterFormView";
import PersistenceTaskAction from "../Tasks/PersistenceTaskAction.json"
import PriorityRank from "../Tasks/PriorityRank";
import CopyTaskAndActivity from "../Tasks/CopyTaskAndActivity";
import ValidateTasks from "../Tasks/ValidateTasks";
import ValidateActivity from "../Tasks/ValidateActivity";
import TaskProgressPopup from "../Tasks/TaskProgressPopup";

var existingFilter = [];
var existingFilterV1 = [];
var masterRiskList = [];
var selectedColumn = undefined;
var currentEditField = undefined;
var workstreamRole = undefined;
export default function TaskRegister(props) {
  const [persistenceTaskGrid, setPersistenceTaskGrid] = React.useState(PersistenceTasks);
  const [persistenceTaskActionGrid, setPersistenceTaskActionGrid] = React.useState(PersistenceTaskAction);
  const [title, setTitle] = React.useState("");
  const [editField, setEditField] = React.useState(undefined);
  const [excelImport, setOpenExcelImport] = React.useState(false);
  const [isTaskImport, setIsTaskImport] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [action, setActivity] = React.useState(null);
  const [currentChangedValue, setCurrentChangedValue] = React.useState({});
  const [stackeHolderList, setStackeHolderList] = React.useState([]);
  const [ownerListForTask, setOwnerListForTask] = React.useState([]);
  const [openPdfTitlePopup, setOpenPdfTitlePopup] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [orgUnit, setOrgUnit] = React.useState({});
  
  const [fixedGrid, setFixedGrid] = React.useState(true);
  const [stickyClassVal, setStickClass] = React.useState("");
  const [riskAddOrEdit, setRiskAddOrEdit] = React.useState(false);

  const [formEditFlag,setFormEditFlag] = React.useState(false);
  const [showFormView,setShowFormView]= React.useState(false);
  const [formData,setFormData]= React.useState({});
  
  const [importRequest, setImportRequest] = React.useState();
  const [importFileName, setImportFileName] = React.useState(undefined);
  const [enable_errorlog,setenable_errorlog]= React.useState(false);
  const [isvalidatepopup,setIsvalidatepopup]= React.useState(false);
  const [errorDataList, setErrorDataList] = useState([]);
  const [dataUploadCount, setDataUploadCount] = useState({
    totalRow:0,
    failedRow:0,
    successRow:0
  });
  const [priorityRankingsList,setPriorityRankingsList]=useState([]);

  const [updatedfield,setUpdatedField]=React.useState(0);
  const [expandedRowList, setExpandRowList] = React.useState([]);
  const [taskValidationDataCount,setTaskValidationDataCount]=React.useState({
    newTaskCount:0,
    modifiedTaskCount:0,
    aggregateCellsCount:0,
    closedTaskCount:0
  });
  const [pendingCommitFlag,setPendingCommitFlag]=React.useState(false);
  const [taskMetrics, setTaskMetrics] = React.useState({});
  const [taskActionMetrics, setTaskActionMetrics] = React.useState({});
  const [validateBtnFlag,SetValidateBtnFlag]= React.useState(false);
  const [excelTemplates,setExcelTemplates]=useState([]);
  const [excelTemplateValue,setExcelTemplatesValue]=useState(undefined);
  
  const pdfExportComponent = React.useRef(null);
  const [filter, setFilter] = React.useState({
    logic: "and",
    filters: [],
  });
  const filterOperators = {
    text: [
      { text: "grid.filterContainsOperator", operator: "contains" },
      { text: "grid.filterNotContainsOperator", operator: "doesnotcontain" },
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterStartsWithOperator", operator: "startswith" },
      { text: "grid.filterEndsWithOperator", operator: "endswith" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
      // { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
      // { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
    ],
    numeric: [
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterGteOperator", operator: "gte" },
      { text: "grid.filterGtOperator", operator: "gt" },
      { text: "grid.filterLteOperator", operator: "lte" },
      { text: "grid.filterLtOperator", operator: "lt" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
    ],
    date: [
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterAfterOrEqualOperator", operator: "gte" },
      { text: "grid.filterAfterOperator", operator: "gt" },
      { text: "grid.filterBeforeOperator", operator: "lt" },
      { text: "grid.filterBeforeOrEqualOperator", operator: "lte" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
    ],
    boolean: [{ text: "grid.filterEqOperator", operator: "eq" }],
  };
  const myRef = useRef();

  var customFieldsData = [];
  var cellAddValue = "";

  const [dataState, setDataState] = React.useState({
    sort: [],
    take: 15,//Math.round((window.innerHeight - 250) / 35),
    skip: 0,
    group: [],
  });
 
  const reportWindowSize = () => {
    if (window.innerWidth > 768) {
      setFixedGrid(true);
      setStickClass("k-grid-content-sticky");
    } else {
      setFixedGrid(false);
      setStickClass("");
    }
  };

  window.addEventListener("resize", reportWindowSize);
  window.addEventListener("load", reportWindowSize);

  const handleOpenExportDialog = (flag) => {
    setOpenExcelImport(true);
    setIsTaskImport(flag);
    setImportRequest({});
    setImportFileName(undefined);
    SetValidateBtnFlag(false);
    setTaskValidationDataCount({
      newTaskCount:0,
      modifiedTaskCount:0,
      aggregateCellsCount:0,
      closedTaskCount:0
    });
    fetchPendingCommitForWorkstream(flag);
  };

  const handleValidateDataCount=(obj)=>{
    setTaskValidationDataCount({
      newTaskCount:obj.newTaskCount,
      modifiedTaskCount:obj.modifiedTaskCount,
      aggregateCellsCount:obj.aggregateCellsCount,
      closedTaskCount:obj.closedTaskCount
    });
  }
    const fetchPendingCommitForWorkstream = async (flag) => {
      try {
        setLoader(true);
        let request = {
          workstreamId: parseInt(props.match.params.taskId),
          excelUploadType: flag===true?"task":"taskaction"
        };
        let response = await Api.fetchPendingCommitForWorkstream(request);
        if (
          response.status === 200 &&
          response.pendingExcelUploader &&
          response.pendingExcelUploader.length > 0
        ) {
          if(flag===true&&response.pendingExcelUploader[0].excelUploadType==="task"){
            setPendingCommitFlag(true);
          }else if(flag===false&&response.pendingExcelUploader[0].excelUploadType==="taskaction"){
            setPendingCommitFlag(true);
          }
          setLoader(false);
        } else {
          setPendingCommitFlag(false);
          setLoader(false);
        }
      } catch (err) {
        setLoader(false);
      }
    };

  const [customFieldsDataState, setCustomFieldsDataState] = React.useState([]);
  const gridRef = useRef(null);

  useEffect(() => {
    existingFilter = [];
    existingFilterV1 = [];
    masterRiskList = [];
    selectedColumn = undefined;
    currentEditField = undefined;
    isAuthorizeUse();
  }, []);
  


  const history = useHistory();
  const isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (props.match.params.id) {
        history.push({
          pathname: `/tenant/${props.match.params.id}`,
        });
      } else {
        history.push({
          pathname: "/",
        });
      }
    } else {
      setLoader(true);
      await getTaskPersistence();
      await getActivityPersistence();
      let res = await getCustomField();
      customFieldsData = res;
      setCustomFieldsDataState(res);
      getAllTenantUserList();
      getAllOwnerList();
      getExcelTemplates();
      await getOrgUnitById();
      reportWindowSize();
      getPriorityRankings();
      //show/hide cols methods
      // await createActivityAndTaskColumns();
      await getColumnSettings("TASK");
      await getColumnSettings("ACTIVITY");
    }
  };

  const getTaskPersistence = async () => {
    try {
      let req = {
        WorkstreamId: parseInt(props.match.params.taskId),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        "screenName": "Task",
      };
      let response = await Api.getTaskPersistence(req);
      if (
        response.status == 200 &&
        response.taskPersistenceResponse &&
        response.taskPersistenceResponse.persistenceDetails
      ) {
          let persis = JSON.parse(response.taskPersistenceResponse.persistenceDetails);
          setPersistenceTaskGrid(persis);
      } 
    } catch (err) {
      console.log(err);
    }
  };

  const getActivityPersistence = async () => {
    try {
      let req = {
        WorkstreamId: parseInt(props.match.params.taskId),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        "screenName": "TaskAction",
      };
      let response = await Api.getTaskPersistence(req);
      if (
        response.status == 200 &&
        response.taskPersistenceResponse &&
        response.taskPersistenceResponse.persistenceDetails
      ) {
      
          let persis = JSON.parse(response.taskPersistenceResponse.persistenceDetails);
          setPersistenceTaskActionGrid(persis);
        
      } 
    } catch (err) {
      console.log(err);
    }
  };
  const refreshPersistence = (event) => {
    try {
      setPersistenceTaskActionGrid(event);
    } catch (err) {
      console.log(err);
    }
  };
  const getTaskMetricsAsync = async () => {
    try {
      var req = {
        workstreamId: parseInt(props.match.params.taskId),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        screenFrom: "Task",
      };
      let response = await Api.getTaskMetricsAsync(req);
      if (response.status === 200 && response.tasksMetricsResponse) {
        setTaskMetrics(response.tasksMetricsResponse);
        setTaskActionMetrics(response.taskActionsMetricsResponse);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getPriorityRankings = async () => {
    try {
      let response = await Api.getPriorityRankings();
      if (response.status === 200) {
        let rankingList = [];

        for (var i = 0; i < response.priorityRankings.length; i++) {
          rankingList.push({
            value: response.priorityRankings[i].priorityRankingId,
            text: response.priorityRankings[i].priorityRankingName,
          });
        }
        setPriorityRankingsList(rankingList);
      } 
    } catch (error) {
      console.error(error);
    }
  };

  const getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.taskId),
      };

      let response = await Api.getCustomField(request);
      if (response.status == 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = convertStrToHash(item1.possibleValues);
          });
          if(item.inputType=="Single Drop Down"){
            let newFirstElement = {
              "hashValue":"",
              "id": 0,
              "possibleValues": " [blank]",
            }
            item["cfPossibleValues"] = [newFirstElement].concat(item.cfPossibleValues);
            item["possibleValues"]=[" [blank]"].concat(item.possibleValues);
          }else if(item.inputType=="Multi Drop Down"){
            let newFirstElement = {
              "hashValue":"",
              "id": 0,
              "possibleValues": " [blank]",
            }
           
            item["cfPossibleValues"] = [newFirstElement].concat(item.cfPossibleValues);
            item["possibleValues"]=[" [blank]"].concat(item.possibleValues);
          }
        });
        res = response.customFields;
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };
  const getExcelTemplates = async () => {
    try {
      let response = await Api.getExcelTemplates();
      if (response.status === 200) {
        setExcelTemplates(response.excelTemplates)
      } 
    } catch (error) {
      console.error(error);
    }
  };

  const getOrgUnitById = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var req = {
        UnitId: parseInt(props.match.params.taskId),
        CreatedBy: parseInt(createdby),
        IsTasksModule:true
      };
      let response = await Api.getOrgUnitById(req);
      if (
        response.status === 200 &&
        response.orgUnitProjectResponses &&
        response.orgUnitProjectResponses.length > 0
      ) {
        setOrgUnit(response.orgUnitProjectResponses[0]);
        workstreamRole = response.orgUnitProjectResponses[0].taskRole;
        let cfArray=response.orgUnitProjectResponses[0].customFields;
        createActivityAndTaskColumns(cfArray);
        await getTasksById();
      } else {
        setOrgUnit({});
        setLoader(false);
        createActivityAndTaskColumns([]);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
      createActivityAndTaskColumns([]);
    }
  };
  


  const getAllTenantUserList = async () => {
    try {
      let response = await Api.getuserAddedByTenant();
      if (response.status === 200 && response.tenantUsers) {
        var typeList = [];
        var tempUserList = [];
        let stackeHolderList = [];
        for (var i = 0; i < response.tenantUsers.length; i++) {
          tempUserList.push({
            value: response.tenantUsers[i].userId,
            text: response.tenantUsers[i].name,
          });
          typeList.push(response.tenantUsers[i].name);
          stackeHolderList.push({
            userId: response.tenantUsers[i].userId,
            displayName:
              response.tenantUsers[i].name +
              " (" +
              response.tenantUsers[i].emailAddress +
              ")",
            email: response.tenantUsers[i].emailAddress,
          });
        }
       
        setStackeHolderList(stackeHolderList);
      }
    } catch (error) {
      setLoader(false);

      console.error(error);
    }
  };

  const getAllOwnerList = async () => {
    try {
      let req = {
        workstreamId: parseInt(props.match.params.taskId),
      };
      let response = await Api.getOwnersByTask(req);
      if (response.status === 200 && response.users) {
        var tempUserList = [];

        for (var i = 0; i < response.users.length; i++) {
          tempUserList.push({
            value: response.users[i].userId,
            text: response.users[i].userName,
          });
        }
        let newFirstElement={
            value: null,
            text: " [blank]",
        }
        tempUserList=[newFirstElement].concat(tempUserList);
        setOwnerListForTask(tempUserList);
      }
    } catch (error) {
      setLoader(false);

      console.error(error);
    }
  };

  const manageCustomValues = async (updateDate) => {
    let type = getInputType(updateDate.inEdit);
    if ((type && type === "Multi Drop Down") || type === "Single Drop Down") {
      updateTaskRegistor(updateDate, false);
    } else {
      let dirtData = masterRiskList.find(
        (item) => updateDate.taskRegisterId == item.taskRegisterId
      );
      if (
        dirtData &&
        updateDate[updateDate.inEdit] == dirtData[updateDate.inEdit]
      ) {
        exitEdit();
        return;
      } else {
        updateTaskRegistor(updateDate, false);
      }
    }
  };


  const [dropdownColumns, setDropdownColumns] = React.useState([]);
  //Custom fields
  const createDynamicDropdowns = (products, filter) => {
    let dropdownColumn = [];
    products.map((res) => {
      res.customFields&&res.customFields.map((item) => {
        if (dropdownColumn.length > 0) {
          if (!dropdownColumn.find((cf) => cf.fieldName == item.fieldName)) {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: getCustomFieldMasterData(item.fieldName, filter),
              inputType: getInputType(item.fieldName),
            });
          }
        } else {
          dropdownColumn.push({
            fieldName: item.fieldName,
            data: getCustomFieldMasterData(item.fieldName, filter),
            inputType: getInputType(item.fieldName),
          });
        }
      });
    });

    if (dropdownColumn.length > 0) {
      products.map((res) => {
        dropdownColumn.map((col) => {
          let temp = res.customFields&&res.customFields.find(
            (item) => item.fieldName === col.fieldName
          );
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              let hashArr = stringToHashForCF(val, col.data);
              res[col.fieldName] = hashArr;
            } else if (temp.inputType === "Single Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Free Text") {
              let val = temp.multiText;
              res[col.fieldName] = val;
            } else if (temp.inputType === "Numeric") {
              let val = temp.multiText;// ? parseInt(temp.multiText) : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Date") {
              let val = temp.multiText ? new Date(temp.multiText) : undefined;
              res[col.fieldName] = val;
            }
          } else {
            res[col.fieldName] = "";
          }
        });
      });
    }
    let columnsToShow = [];
    if (dropdownColumn.length > 0) {
      columnsToShow = dropdownColumn.map((item) => (
        <GridColumn
          field={item.fieldName}
          title={item.fieldName}
          // width={getFieldWidth(item.fieldName)}
          width={"200px"}
          cell={(props) => getCustomFieldComponent(props, products, item)}
          columnMenu={(props) => getCustomFieldColumnMenu(props, item)}
          filter={getCustomFieldFilter(item)}
          headerClassName={checkItsinFilterOrNot(item.fieldName, filter)}
        />
      ));
    }
    setDropdownColumns(columnsToShow);
  };

  const getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };
  const getcustomfieldfilterlist=(list)=>{
    var sorted_arr =  list.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return sorted_arr
  }

  const getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      getcustomfieldfilterlist(item.data);
      return (
        <CustomFieldSearchMenu
          {...props}
          customFieldsmaster={item.data}
          existingFilter={existingFilter ? existingFilter : existingFilterV1}
          filterChangeV={filterChangeV}
          clearFilter={clearFilter}
        />
      );
    }else if(item.inputType === "Single Drop Down"){
      return (                      
        <ColumnMenuCheckboxFilter
          {...props}
          data={masterRiskList}
          getSelectedColumn={getSelectedColumn}
        />
      )
    } else {
      return (
        <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
      );
    }
  };


  const getCustomFieldComponent = (props, products, cfObj) => {
    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      return (
        <TaskCustomFieldMultiDropdown
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <TaskCustomFieldSingleDropdown
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <TaskCustomFieldFreeText
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <TaskCustomFieldNumber
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <TaskCustomFieldDate
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else {
      return <td></td>;
    }
  };

  const getInputType = (fieldName) => {
    try {
      if (customFieldsData.length == 0) {
        customFieldsData = customFieldsDataState;
      }
      let arr = customFieldsData.find((item) => item.fieldName == fieldName);
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCustomFieldMasterData = (fieldName, filter) => {
    try {
      if (customFieldsData.length == 0) {
        customFieldsData = customFieldsDataState;
      }
      let arr = customFieldsData.filter((item) => item.fieldName == fieldName);
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked = checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
 
  const setClassName = (field) => {
    let headerClassName = "";
    if (filter && filter.filters) {
      filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };

  const checkItsinFilterOrNot = (field, exfilter) => {
    try {
      let headerClassName = "";
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = "active";
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = "active";
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {}
  };

  const checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };


  const getTasksById = async () => {
    try {
      setLoader(true);
      var request = {
        workstreamIds: [parseInt(props.match.params.taskId)],
        ScreenFrom:"Task"
      };
      let response = await Api.getTasksById(request);
      if (response.status === 200 && response.taskRegisters) {
        currentEditField = undefined;
        response.taskRegisters.map((riskReg) => {
          if (expandedRowList.includes(riskReg.taskRegisterId)) {
            riskReg["expanded"] = true;
          } else {
            riskReg["expanded"] = false;
          }
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            ); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            ); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            ); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate ? new Date(closedDate) : "";
          }
          if (workstreamRole) {
            riskReg["role"] = workstreamRole;
          }

          if (riskReg.riskAlertStakeHolders) {
            riskReg["riskAlertStakeHolders"] =
              riskReg["riskAlertStakeHolders"].toString();
          }
          let str = "";
          if (riskReg.taskProgressComments) {
            riskReg.taskProgressComments.map((cmt) => {
              str +=
                " Name:" +
                cmt.userName +
                "\n Date:" +
                moment(new Date(cmt.createdDate)).format(
                  "DD-MMM-yyyy HH:mm:ss"
                ) +
                "\n Comments: " +
                cmt.taskComment +
                "\r\n";
            });
            riskReg["progressHistory"] = str;
          } else {
            riskReg["progressHistory"] = null;
          }
          if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }

          if (!riskReg.taskOwnerName) {
            riskReg.taskOwnerName = undefined;
          }
        });

        let filter = existingFilter ? existingFilter : [];
        await createDynamicDropdowns(response.taskRegisters, filter);
        const result = filterBy(response.taskRegisters, filter);
        getTaskMetricsAsync();
        setData(result);
        setActivity(constructActivityDataForExcelExport(result));
        masterRiskList = response.taskRegisters;
        setLoader(false);
      } else {
        setData([]);
        getTaskMetricsAsync();
        setLoader(false);
        masterRiskList=[];
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
      masterRiskList=[];
      setData([]);
      getTaskMetricsAsync();
    }
  };

  const constructActivityDataForExcelExport = (taskRegisters) => {
    var taskActionsArray = [];
    taskRegisters.map((reg) => {
      if (reg.taskActions && reg.taskActions.length > 0) {
        for (let taskActions in reg.taskActions) {
          let actionObj = reg.taskActions[taskActions];
          if (actionObj.originalCompletionDate) {
            actionObj.originalCompletionDate =actionObj.originalCompletionDate? moment(new Date(actionObj.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (actionObj.projectedCompletionDate) {
            actionObj.projectedCompletionDate =actionObj.projectedCompletionDate? moment(new Date(actionObj.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (actionObj.actualCompletionDate) {
            actionObj.actualCompletionDate =actionObj.actualCompletionDate? moment(new Date(actionObj.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (actionObj.proximityAlertDate) {
            actionObj.proximityAlertDate =actionObj.proximityAlertDate? moment(new Date(actionObj.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (actionObj.updatedDate) {
            var time = moment(actionObj.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            actionObj.updatedDate = actionObj.updatedDate
              ? moment(new Date(updatedDate)).format("DD-MMM-YYYY")
              : "";
          }
          if (actionObj.createdDate) {
            let time = moment(actionObj.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            actionObj.createdDate = actionObj.createdDate
              ? moment(new Date(createdDate)).format("DD-MMM-YYYY")
              : "";
          }
          if (actionObj.closedDate) {
            let time = moment(actionObj.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            actionObj.closedDate = actionObj.closedDate
              ? moment(new Date(closedDate)).format("DD-MMM-YYYY")
              : "";
          }
          let str = "";
          if (actionObj.actionProgressComments) {
            actionObj.actionProgressComments.map((cmt) => {
              str +=
                " Name:" +
                cmt.userName +
                "\n Date:" +
                moment(new Date(cmt.createdDate)).format(
                  "DD-MMM-yyyy HH:mm:ss"
                ) +
                "\n Comments: " +
                cmt.taskActionComment +
                "\r\n";
            });
            actionObj["progressHistory"] = str;
          } else {
            actionObj["progressHistory"] = null;
          }
          if(actionObj.isApproved===true||actionObj.isApproved==="Yes"){
            actionObj["isApproved"] ="Yes";
          }else{
            actionObj["isApproved"] ="No";
          }
          if(actionObj.isClosed===true||actionObj.isClosed==="Closed"){
            actionObj["isClosed"]="Closed";
          }else{
            actionObj["isClosed"]="Open";
          }
          if (actionObj.alertStakeHolders) {
            actionObj["alertStakeHolders"] =
            actionObj["alertStakeHolders"].toString();
          }
          taskActionsArray.push(actionObj);
        }
      }
     
    });
    return taskActionsArray;
  };
  const riskRegistorUpdateValidation = async (Value) => {
    var flag = true;
    var msg = "";

    if (!Value.taskTitle || Value.taskTitle.trim() == "") {
      flag = false;
      msg = "The task title";
    }

    if (!flag) {
      toastr.error(msg + " are required");
    }
    return flag;
  };


  const refreshTask = async () => {
    setLoader(true);
    if (customFieldsData.length === 0) {
      let res = await getCustomField();
      customFieldsData = res;
      setCustomFieldsDataState(res);
    }
    getTasksById();
  };
  const processInput=(input) =>{
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  }
  const updateTaskRegistor = async (taskObj, flag) => {
    try {
      console.log("updateDate-101",taskObj);
      setLoader(true);
      if (flag) {
        var flag = await riskRegistorUpdateValidation(taskObj);

        if (!flag) {
          setLoader(false);
          return;
        }
      }
      taskObj.isClosed=taskObj.isClosed==="Closed" || taskObj.isClosed===true ? true : false;

      if(taskObj.inEdit==="isClosed"&&taskObj.isClosed===false && taskObj.percentageCompletion>=100 ){
        taskObj.percentageCompletion=0;
      }

      if(taskObj.inEdit==="isClosed"&&taskObj.isClosed===false && taskObj.actualCompletionDate){
        taskObj.actualCompletionDate=null;
      }

      if(taskObj.percentageCompletion>=100){
        taskObj.isClosed=true;
        taskObj.actualCompletionDate=new Date();
      } 
      if(taskObj.percentageCompletion>=100 && !taskObj.actualCompletionDate){
        taskObj.isClosed=true;
        taskObj.actualCompletionDate=new Date();
      } 

      if(taskObj.actualCompletionDate){
        taskObj.isClosed=true;
      }

      if(taskObj.originalCompletionDate && !taskObj.projectedCompletionDate){
        taskObj.projectedCompletionDate = taskObj.originalCompletionDate;
      }
      if(taskObj.projectedCompletionDate && !taskObj.originalCompletionDate){
        taskObj.originalCompletionDate = taskObj.projectedCompletionDate;
      }
      if (taskObj.inEdit == "originalCompletionDate") {
        taskObj.projectedCompletionDate = taskObj.originalCompletionDate;
      }
      if(taskObj.isClosed===false){
        taskObj.actualCompletionDate=null;
      }
      
      let request = {
        taskRegisterId: taskObj.taskRegisterId,
        organizationUnitId: taskObj.organizationUnitId,
        taskCustomFields: taskObj.taskCustomField?[taskObj.taskCustomField]:[],
        isApproved: taskObj.isApproved==="Yes" || taskObj.isApproved===true ? true : false,
        isClosed: taskObj.isClosed,
        taskTitle: taskObj.taskTitle?.slice(0, 30),
        taskDescription: taskObj.taskDescription,
        cost: taskObj.cost,
        effort: taskObj.effort,
        taskOwner: taskObj.ownerId?{"value":taskObj.ownerId, "text":taskObj.taskOwnerName}:null,        
        percentageOnTrack: taskObj.percentageOnTrack>100?100:taskObj.percentageOnTrack,
        percentageCompletion:taskObj.percentageCompletion>100?100:taskObj.percentageCompletion,

        proximityAlertDate: taskObj.proximityAlertDate?moment(taskObj.proximityAlertDate).format("YYYY-MM-DD"):null,
        originalCompletionDate: taskObj.originalCompletionDate?moment(taskObj.originalCompletionDate).format("YYYY-MM-DD"):null,
        projectedCompletionDate: taskObj.projectedCompletionDate?moment(taskObj.projectedCompletionDate).format("YYYY-MM-DD"):null,
        actualCompletionDate: taskObj.actualCompletionDate?moment(taskObj.actualCompletionDate).format("YYYY-MM-DD"):null,

        delayConsequence: taskObj.delayConsequence,
        alertStakeHolders: processInput(taskObj.alertStakeHolders),
        alertDescription: taskObj.alertDescription,
        priorityRankingId:taskObj.priorityRankingId,
        effortUnitId:taskObj.effortUnitId,

        progressComment: editField == "progressComment" ? taskObj.progressComment : null,
      };

      let response = await Api.addTaskRegisterAsync(request);
      if (response.status === 200) {
        
        var res = masterRiskList.map((obj) => {
          if (obj && obj.taskRegisterId == taskObj.taskRegisterId) {

            obj = response.riskReg;
          }
          return obj;
        });
        setUpdatedField(taskObj.taskRegisterId);
        refreshTask(res, "update", taskObj.taskRegisterId);
        setCurrentChangedValue({});
      } else {
        refreshTask();
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };
  
  const openTaskFormView=()=>{
    setShowFormView(true);
  }

  const closeRiskFormView=()=>{
    setShowFormView(false);
    setFormEditFlag(false);
    setFormData({});
  }

  const addRiskDataFromForm=()=>{
    try{
       getTasksById();
      // if(flag==="UPDATE"){
      //   var res = masterRiskList.map((obj) => {
      //     if (obj && obj.taskRegisterId == formData.taskRegisterId) {
  
      //       obj = formData;
      //     }
      //     return obj;
      //   });
      //   setUpdatedField(formData.taskRegisterId);
      //   refreshRisk(res, "update", formData.taskRegisterId);
      //   setCurrentChangedValue({});
      // }else if(flag==="ADD"){
      //    masterRiskList.unshift(formData);
      //   refreshRisk(masterRiskList, "update", formData.taskRegisterId);
      // }
      
    }catch(err){
      console.error(err);
    }
  }

  const customCellEdit = (dataItem, field, riskData) => {
    try {
      let filter = existingFilter ? existingFilter : [];
      const result = filterBy(riskData, filter);
      const dataValue = result.map((item) => ({
        ...item,
        inEdit:
          item.taskRegisterId === dataItem.taskRegisterId ? field : undefined,
      }));
      currentEditField = field;
      createDynamicDropdowns(result, filter);
      setData(dataValue);
      setEditField(field);
      setCurrentChangedValue(dataItem);
      setActivity(constructActivityDataForExcelExport(result));
    } catch (err) {}
  };

  const enterEdit = (dataItem, field) => {
    try {
      const dataValue = data.map((item) => ({
        ...item,
        inEdit:
          item.taskRegisterId === dataItem.taskRegisterId ? field : undefined,
      }));
      currentEditField = field;
      setData(dataValue);
      setEditField(field);
      setCurrentChangedValue(dataItem);
    } catch (err) {}
  };

  const exitEdit = () => {
    const dataValue = data.map((item) => ({ ...item, inEdit: undefined }));
    currentEditField = undefined;
    setData(dataValue);
    setEditField(undefined);
  };

  const cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];
    const additionalProps =
      cellField && cellField === inEditField
        ? {
            ref: (td) => {
              const input = td && td.querySelector("input");
              const activeElement = document.activeElement;

              if (
                !input ||
                !activeElement ||
                input === activeElement ||
                !activeElement.contains(input)
              ) {
                return;
              }

              if (input.type === "checkbox") {
                input.focus();
              } else {
                input.select();
              }
            },
          }
        : {
            onClick: () => {
              enterEdit(dataItem, cellField);
            },
            onFocus: () => {
              enterEdit(dataItem, cellField);
            },
            tabIndex: "0",
          };
        
    if (tdElement && tdElement.props ) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps ,},
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  const rowRender = (trElement,props) => {
     const RiskrowId =updatedfield;
    const bgcolor={
      backgroundColor:"rgba(0, 255, 76, 0.308)",
    }
      const trProps = {
        ...trElement.props,
        style: RiskrowId == props.dataItem.taskRegisterId ? bgcolor : null,

        onMouseDown: (event) => {
          event.preventExit = true;
          clearTimeout(event.preventExitTimeout);
          event.preventExitTimeout = setTimeout(() => {
            event.preventExit = undefined;
          });
        },
        onBlur: (event) => {
          currentEditField = editField;

          if (editField === "alertStakeHolders" || editField === "progressComment") {
            return;
          }
          clearTimeout(event.blurTimeout);
          if (!event.preventExit) {
            event.blurTimeout = setTimeout(() => {
              exitEdit();
            });
          }
        },
        onFocus: (event) => {
          clearTimeout(event.blurTimeout);
        },
      };
   
    return React.cloneElement(
      trElement,
      {
        ...trProps,
      },
    
      trElement.props.children
    );
  };

  const itemChange = async (event) => {
    let changedValue;
    let dataValue;
    changedValue = { ...event.dataItem, [event.field]: event.value };
    dataValue = data.map((item) =>
      item.taskRegisterId === event.dataItem.taskRegisterId
        ? { ...item, [event.field]: event.value }
        : item
    );
    setData(dataValue);
    setCurrentChangedValue((preState) => ({ ...preState, ...changedValue }));
  };
  const expandChange = React.useCallback(
    (dataItem) => {
      dataItem.expanded = !dataItem.expanded;
      let expandRow = expandedRowList ? expandedRowList : [];

      //scroll reset
      document
        .getElementById("DataGrid")
        .getElementsByClassName("k-grid-content")[0].scrollLeft = 0;
      //
      if (expandRow.includes(dataItem.taskRegisterId)) {
        let expanedState = expandedRowList;
        let indexValue = expanedState.findIndex(
          (item) => dataItem.taskRegisterId === item
        );
        expanedState.splice(indexValue, 1);
        expandRow = expanedState;
      } else {
        expandRow.push(dataItem.taskRegisterId);
      }
      data.map((riskReg) => {
        if (riskReg.taskRegisterId === dataItem.taskRegisterId) {
          riskReg["expanded"] = dataItem.expanded;
        }
      });
      setExpandRowList(expandRow);
      setData([...data]);
     
      masterRiskList = [...data];
    },
    [data, setData, expandedRowList, setExpandRowList]
  );

  const editFormView = (dataItem) => {
    try {
      setFormEditFlag(true);
      setFormData(dataItem);
      setShowFormView(true);
      if(myRef&&myRef.current){
        myRef.current.loadEditmode(dataItem);
      }
    } catch (err) {
      console.log(err);
    }
  };
const actionButtonsForViewOnly = (event) => {
  let eventData = event;
  return (
    <td className={stickyClassVal} style={{ left: "42px", right: "0px" }}>
      <ul className="actionIcon">
        <li>
          <a
            title="View"
            className="greenbtn"
            onClick={() => editFormView(eventData.dataItem)}
          >
            <img src={Images.VIEW} width="12" alt="More" />
          </a>
        </li>
      </ul>
    </td>
  );
};
  const actionButtons = (event) => {
    let eventData = event;
    return (
      <td className={stickyClassVal} style={{ left: "42px", right: "0px" }}>
        <ul className="actionIcon">
          <li>
            <a
              title="View"
              className="greenbtn"
              onClick={() => editFormView(eventData.dataItem)}
            >
              <img src={Images.VIEW} width="12" alt="More" />
            </a>
          </li>
          <li>
            <a
              title="Documents"
              className={
                eventData.dataItem.documentCount == 0
                  ? "greenbtn roundedBtn icon"
                  : "bluebtn roundedBtn icon"
              }
            >
              <NavLink
                title="Document"
                className={
                  eventData.dataItem.documentCount == 0
                    ? "greenbtn icon"
                    : "bluebtn icon"
                }
                to={`/${secureLocalStorage.getItem(
                  "loggedClient"
                )}/${secureLocalStorage.getItem(
                  "tenantKey"
                )}/home/documents/taskregisterdocs/${
                  eventData.dataItem.taskRegisterId
                }`}
              >
                <img
                  src={
                    eventData.dataItem.documentCount == 0
                      ? Images.DOCUMENT
                      : Images.DOCUMENTBLUE
                  }
                  width="12"
                  alt="Document"
                />
              </NavLink>
            </a>
          </li>
          <li>
            <a
              title="Delete"
              className="redbtn icon"
              onClick={() => deleteRiskPopupOpen(eventData.dataItem)}
            >
              <img src={Images.TRASH} width="12" alt="More" />
            </a>
          </li>
        </ul>
      </td>
    );
  };

  const manageButtons = (event) => {
    let eventData = event;
    return eventData.dataItem.taskRegisterId != undefined &&
      eventData.dataItem.taskRegisterId != "" ? (
      <td className={stickyClassVal} style={{ left: "107px", right: "0px" }}>
        <ul className="actionIcon">
          <li>
            <a
              title="Documents"
              className={
                eventData.dataItem.documentCount == 0
                  ? "greenbtn roundedBtn icon"
                  : "bluebtn roundedBtn icon"
              }
            >
              {/* <img src={Images.DOCUMENT} width="12" alt="Cancel" /> */}

              <NavLink
                title="Document"
                className={
                  eventData.dataItem.documentCount == 0
                    ? "greenbtn icon"
                    : "bluebtn icon"
                }
                to={`/${secureLocalStorage.getItem(
                  "loggedClient"
                )}/${secureLocalStorage.getItem(
                  "tenantKey"
                )}/home/documents/taskregisterdocs/${
                  eventData.dataItem.taskRegisterId
                }`}
              >
                <img
                  src={
                    eventData.dataItem.documentCount == 0
                      ? Images.DOCUMENT
                      : Images.DOCUMENTBLUE
                  }
                  width="12"
                  alt="Document"
                />
              </NavLink>
            </a>
          </li>
        </ul>
      </td>
    ) : (
      <td
        className="k-grid-content-sticky manageBtns"
        style={{ left: "107px", right: "0px" }}
      ></td>
    );
  };


  const [openDeleteModelFlag, setOpenDeleteModelFlag] = React.useState(false);
  const [currentRowId, setCurrentRowId] = React.useState(0);
  const [taskActionCount, setActivitiesCount] = React.useState(0);
  const deleteRiskPopupOpen = (row) => {
    setOpenDeleteModelFlag(true);
    setCurrentRowId(row.taskRegisterId);
    setActivitiesCount(row.taskActionCount);
  };

  const deleteRiskPopupClose = () => {
    setOpenDeleteModelFlag(false);
    setCurrentRowId(0);
    setActivitiesCount(0);
  };

  const deleteTask = async () => {
    try {
      var requestParams = {
        taskId: currentRowId,
      };
      setLoader(true);
      let response = await Api.deleteTask(requestParams);
      setLoader(false);

      if (response.status === 200) {
        toastr.success(response.message);
        setOpenDeleteModelFlag(false);
        getTasksById();
        getTaskMetricsAsync();
      } else {
        toastr.error(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const _exporter = React.createRef();
  const _exporterAction = React.createRef();
  const exporter = () => {
    // setActionGridflag(false);
    const risksheet = _exporter.current.workbookOptions();
    const actionsheet = _exporterAction.current.workbookOptions();
    risksheet.sheets[1] = actionsheet.sheets[0];
    risksheet.sheets[0].title = "Task";
    risksheet.sheets[1].title = "Activities";

    _exporter.current.save(risksheet);
  };
  const exportExcel =async () => {
    if (_exporter.current) {
      let filteredData = filterBy(data, filter);
      filteredData.map((riskReg) => {
        //riskReg["isClosed"] = riskReg.isClosed ? "Open" : "Closed";
        Object.keys(riskReg).map(function (field) {
          if (RiskColumns.hasOwnProperty(field)) {
            
            if (riskReg.alertStakeHolders) {
              riskReg["alertStakeHolders"] =
                riskReg["alertStakeHolders"].toString();
            }
          } else {
            //Custom field
            let arr = riskReg.customFields ? riskReg.customFields : [];
            let temp = arr.find((item) => item.fieldName == field);
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                riskReg[field] = temp.selectedCustomFieldNames.toString();
              } else if (temp.inputType === "Single Drop Down") {
                riskReg[field] = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
              } else if (temp.inputType === "Free Text") {
                riskReg[field] = temp.multiText;
              } else if (temp.inputType === "Numeric") {
                riskReg[field] = temp.multiText;// ? parseInt(temp.multiText) : "";
              } else if (temp.inputType === "Date") {
                riskReg[field] = temp.multiText
                  ? new Date(temp.multiText)
                  : undefined;
              }
            } 
          }
        });
      });
      await exporter();
      filteredData.map((riskReg) => {
        if (expandedRowList.includes(riskReg.taskRegisterId)) {
          riskReg["expanded"] = true;
        } else {
          riskReg["expanded"] = false;
        }

      
        if (riskReg.alertStakeHolders) {
          riskReg["alertStakeHolders"] =
            riskReg["alertStakeHolders"].split(",");
        }

        //customFields
        let riskObj = masterRiskList.find(
          (item) => item.taskRegisterId === riskReg.taskRegisterId
        );
        if (riskObj) {
          riskReg["customFields"] = riskObj.customFields;
        }
      });
      
      createDynamicDropdowns(filteredData,filter.filters);
      
    }
  };

  const updateTaskRegisterDropDown = async (updateDate) => {
    await updateTaskRegistor(updateDate, true);
    exitEdit();
  };


  const getMergedRangeForRowAndHeader = (merges, rowNumber, headerKey, headers) => {
      try{
        const headerIndex = headers.indexOf(headerKey); // Get the column index for the given header
    
        if (headerIndex === -1) {
          console.error(`Header "${headerKey}" not found.`);
          return 0; // Return null if the header is not found
        }
    
          // Check if any merged range includes the specified row and header's column
        for (let merge of merges) {
          const { s: start, e: end } = merge;
  
          // If the merge includes the specified row and the header's column
          if (start.r <= rowNumber - 1 && end.r >= rowNumber - 1 && start.c <= headerIndex && end.c >= headerIndex) {
            // return `${start.r + 1}-${end.r + 1}`;
            return Math.floor(((end.r + 1)-(start.r + 1))/2);
          }
        }
    
      return 0; // If no merged range found
      }catch(err){
        console.error(err)
      }
    
  };
  const handleUpload = (event) => {
    try{
      setImportRequest({});
      var file = event.target.files[0];
      var name = file ? file.name : "invalid file";
      setImportFileName(name);
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          cellText: true,
          cellDates: true,
        });
        const worksheet = workbook.Sheets[excelTemplateValue.templateSheetName];
        if (worksheet) {
         
          const range = XLSX.utils.decode_range(worksheet['!ref']);
          range.s.r = excelTemplateValue.selectedRowNumber - 1;  // Adjust the start row (0-indexed)
          const newRange = XLSX.utils.encode_range(range);
          const dataFromRow = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            range: newRange,
            raw: false,
            dateNF: "dd-MMM-yyyy",
            // defval: '',  // Default value for empty cells
          });
    
      
          // Convert the array of arrays to an array of objects
          const headers = dataFromRow[0];
          const rows = dataFromRow.slice(1);
          const jsonObjectRisk=[];
          const jsonObjectAction=[];
      
           rows.map((row,i) => {
            let objRisk = {};
            let objAction={};
            headers.forEach((header, index) => {
              header=header.replace(/[\n\r]/g, '');
              objAction[header] = row[index]?cleanNumber(row[index]):null;
              if (header in objRisk) {
                //exists in myObject
              } else {
                objRisk[header] = row[index]?cleanNumber(row[index]):null;
              }
              
            });
         
            if (worksheet["!merges"] && worksheet["!merges"].length > 0) {
              // Get the merged range information for the given row and header key
              const rowNumber=(i+1) + excelTemplateValue.selectedRowNumber;
              let mergedRange = 0;
              if (worksheet['!merges']) {
                mergedRange = getMergedRangeForRowAndHeader(worksheet['!merges'], rowNumber, headers[1], headers);
              }
              objRisk["rowNumber"] = (i+1) + (excelTemplateValue.selectedRowNumber+mergedRange);
              objAction["rowNumber"] = (i+1) + excelTemplateValue.selectedRowNumber;
            } else {
              objRisk["rowNumber"] = (i+1) + excelTemplateValue.selectedRowNumber;
              objAction["rowNumber"] = (i+1) + excelTemplateValue.selectedRowNumber;
            }
              jsonObjectRisk.push(objRisk);
              jsonObjectAction.push(objAction);
            });
          let tempObj={};//"Threat / Opportunity"
          let riskTitleMappingKey=excelTemplateValue.templateColumns.find((item)=>item.riskwellColumnName==="Task Title")?.excelColumnName;
  
          let riskArr=jsonObjectRisk.filter((item)=>item[riskTitleMappingKey]!=undefined);
  
          console.log("TaskArr",riskArr);
          tempObj["RISK"]=riskArr;
  
          let crossRefMappingKey=excelTemplateValue.templateColumns.find((item)=>item.riskwellColumnName==="Task Title")?.excelColumnName;
          let actionArr=jsonObjectAction.filter((item)=>item[crossRefMappingKey]!=undefined);
          console.log("ActivityArr",actionArr);
          tempObj["ACTION"]=actionArr;
          setImportRequest(tempObj);
        } else {
          toastr.error('Sheet name not found');
        }
      }
      reader.readAsArrayBuffer(file);
    }catch(err){
      console.error(err);
    }
    
  };
  const cleanNumber = (value) => {
    if (typeof value === "string" && value.includes("%")) {
      let cleanedValue = value.replace("%", "").trim();
      let numberValue = parseFloat(cleanedValue);
      return isNaN(numberValue) ? value : numberValue;
    } else if (typeof value === "number") {
      return value;
    }
    return value;
  };
  const renderSubtrees = (trees) => {
    return trees?.map((tree,index) => {
      return (
        <TreeItem key={index} id={index} toggled={tree.toggled} title={tree.name}>
          {renderSubtrees(tree.subtrees)}
        </TreeItem>
      );
    });
  };
 
  const downloadErrorLogFile=()=>{
    let arr = errorDataList.map((item) => {
      item["toggled"] = true;
      return item;
    });
    setErrorDataList(arr);
    setTimeout(() => {
      if (pdfExportComponent.current) {
        pdfExportComponent.current.save();
      }
      let arr1 = errorDataList.map((item) => {
        item["toggled"] = false;
        return item;
      });
      setErrorDataList(arr1);
    }, 1000);
  }

  const saveTaskDataUploadFile = async () => {
    try {
      setLoader(true);
      var requestParams = {
        TemplateId: excelTemplateValue.templateId,
        TaskListByExcel:importRequest.RISK,
        workstreamId: parseInt(props.match.params.taskId),
      };
      let response = await Api.SaveTasksByExcelUpload(requestParams);
      if (response.excelTemplateSaveTaskResponse) {
        setLoader(false);
        let errorList =
          response.excelTemplateSaveTaskResponse?.excelExceptionList.filter(
            (item) => item.isRowPassed === false
          );
        if (errorList.length === 0) {
          SetValidateBtnFlag(true);
        } else {
          setenable_errorlog(true);
          SetValidateBtnFlag(false);
          let errArr = [];
          errorList.map((row) => {
            let obj = {};
            let childrenArr = [];
            obj["toggled"] = false;
            obj["name"] = "Row " + row.rowNumber + " Failed - "+row.rowTitle;
            let errorCols = row.excelExceptionColumnList.filter(
              (cols) => cols.isPassed === false
            );
            errorCols.map((errorcol) => {
              childrenArr.push({
                name: errorcol.excelColumnName+": "+errorcol.exceptionMessage,
                toggled:false
              });
            });
            obj["subtrees"] = childrenArr;
            errArr.push(obj);

          });
          setErrorDataList(errArr);
        }
        setDataUploadCount({
          totalRow:requestParams?.TaskListByExcel?.length,
          failedRow:errorList?.length,
          successRow:(requestParams?.TaskListByExcel?.length-errorList?.length)
        });
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  const saveActivityDataUploadFile = async () => {
    try {
      setLoader(true);
      var requestParams = {
        TemplateId: excelTemplateValue.templateId,
        TaskActionListByExcel: importRequest.ACTION,
        workstreamId: parseInt(props.match.params.taskId),
      };
      let response = await Api.SaveTaskActionsByExcelUpload(requestParams);
      if (response.excelTemplateSaveTaskActionResponse) {
        setLoader(false);
        let errorList =
          response.excelTemplateSaveTaskActionResponse?.excelExceptionList.filter(
            (item) => item.isRowPassed === false
          );
        if (errorList.length === 0) {
          SetValidateBtnFlag(true);
        } else {
          setenable_errorlog(true);
          SetValidateBtnFlag(false);

          let errArr = [];
          errorList.map((row) => {
            let obj = {};
            let childrenArr = [];
            obj["toggled"] = false;
            obj["name"] = "Row " + row.rowNumber + " Failed - "+row.rowTitle;
            let errorCols = row.excelExceptionColumnList.filter(
              (cols) => cols.isPassed === false
            );
            errorCols.map((errorcol) => {
              childrenArr.push({
                name: errorcol.excelColumnName+": "+errorcol.exceptionMessage,
                toggled:false
              });
            });
            obj["subtrees"] = childrenArr;
            errArr.push(obj);
          });
          console.log("errArr", errArr);
          setErrorDataList(errArr);
        }
        setDataUploadCount({
          totalRow:requestParams?.ActionListByExcel?.length,
          failedRow:errorList?.length,
          successRow:(requestParams?.ActionListByExcel?.length-errorList?.length)
        });
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  const enable_validatepopup=()=>{
    setIsvalidatepopup(true)
  }

  const cancelvalidate=()=>{
    setIsvalidatepopup(false);
  }
  const commitTasks=async(flag)=>{
    try{
      setLoader(true);
      let request={
        WorkstreamId:parseInt(props.match.params.taskId),
        action:flag
      }
      let response =isTaskImport? await Api.CommitTasksByExcelUpload(request):await Api.CommitTaskActionsByExcelUpload(request);
      if (response.status === 200) {
        if(flag==="commit"){
          toastr.success(response.message);
        }
        setIsvalidatepopup(false);
        setIsTaskImport(false);
        closepopup();
        setExpandRowList([]);
        refreshTask();
        setLoader(false);
      }else{
        setExpandRowList([]);
        cancelvalidate();
        setLoader(false);
      }
    }catch(err){
      setLoader(false);
      console.error(err);
    }
  }
  const closepopup=()=>{
    setOpenExcelImport(!excelImport);
    setenable_errorlog(false);
    setErrorDataList([]);
    setImportRequest(undefined);
    setExcelTemplatesValue(undefined);
    setTaskValidationDataCount({
      newTaskCount:0,
      modifiedTaskCount:0,
      aggregateCellsCount:0,
      closedTaskCount:0
    });
    setPendingCommitFlag(false);
  }

  const expandCell = (props) => (
    <GridExpandComponent {...props} expandChange={expandChange} />
  );

  const handleCellAddValue = (element) => {
    cellAddValue = element;
  };


  const convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };
  const stringToHashForCF = (stringArr, data) => {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    // console.log(hashArr.toString(),stringArr)
    return hashArr.toString();
  };
  const filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      let filterData = existingFilter ? existingFilter : [];
      let filter = e.filter ? e.filter.filters : [];

      // Get the field being filtered from the new filter
      const newFilterFields = new Set();
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }

      // Remove any existing filters for the same fields
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });

      // Combine filtered existing filters with new filters
      let combinedFilters = [...filteredExisting, ...filter];

      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];

      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }
      existingFilterV1 = [...dedupedFilters];
      existingFilter = dedupedFilters;
      const result = filterBy(masterRiskList, dedupedFilters);
      await createDynamicDropdowns(result, dedupedFilters);
      setActivity(constructActivityDataForExcelExport(result));
      setData(result);
     
      setDataState({
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        group: [],
      });
      setFilter({
        logic: "and",
        filters: dedupedFilters,
      });
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (existingFilter) {
        let filterData = existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Only add the filter if none of its inner filters match the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === selectedColumn
            );
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            if (filter2.field != selectedColumn) {
              if (!exi.includes(filter2)) {
                exi.push(filter2);
              }
            }
          }
        });
      }

      existingFilter = exi;
      existingFilterV1 = [...exi];
      const result = filterBy(masterRiskList, exi);
      await createDynamicDropdowns(result, exi);
      setActivity(constructActivityDataForExcelExport(result));
      setData(result);
    
      setDataState({
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        group: [],
      });
      setFilter({
        logic: "and",
        filters: exi,
      });
    }
  };

  const filterChangeV = async (e, colname) => {
    // let exi = existingFilter ? existingFilter : existingFilterV1;
    let exi = [];

    let filterData = existingFilter ? existingFilter : existingFilterV1;
    filterData.map((filter2) => {
      if (filter2.filters) {
        filter2.filters.map((innerFilter) => {
          if (innerFilter.field != colname) {
            if (!exi.includes(filter2)) {
              exi.push(filter2);
            }
          }
        });
      } else {
        if (filter2.field != colname) {
          if (!exi.includes(filter2)) {
            exi.push(filter2);
          }
        }
      }
    });

    let filter = e ? e.filters : [];
    let temp = [];
    if (filter.length > 0) {
      temp = [
        {
          filters: filter,
          logic: "or",
        },
      ];
    }
    let arr = [...exi, ...temp];

    existingFilter = arr;
    const result = filterBy(masterRiskList, arr);
    await createDynamicDropdowns(result, arr);
    setActivity(constructActivityDataForExcelExport(result));
    setData(result);
   
    setFilter({
      logic: "and",
      filters: arr,
    });
    setDataState({
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      group: [],
    });
  };
  const clearFilter = async (e) => {
    let filter = e ? e : [];
    const result = filterBy(masterRiskList, filter);
    await createDynamicDropdowns(result, filter);
    existingFilter = filter;
    setData(result);
    setFilter({
      logic: "and",
      filters: filter,
    });
   
    setActivity(constructActivityDataForExcelExport(result));
  };

  const onColumnReorder = async (event) => {
    try {
      if(event){
        // const newArray=mergeAndUpdateArrays(persistenceRiskGridTemp,event.target.columnResize.columns);

        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          workstreamId: parseInt(props.match.params.taskId),
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          "screenName": "Task",
        };
        await Api.addTaskPersistence(req);
      }else{
        //Reset

        let req = {
          persistenceDetails: null,
          WorkstreamId: parseInt(props.match.params.taskId),
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          "screenName": "Task",
        };
        await Api.addTaskPersistence(req);
      }

    } catch (err) {
      console.log(err);
    }
  };


  const onColumnResize = async (event) => {
    if (event.end) {
      try {
        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          WorkstreamId: parseInt(props.match.params.taskId),
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          "screenName": "Task",
        };
        await Api.addTaskPersistence(req);
        // setPersistenceTaskGrid([...event.target.columnResize.columns]);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const [resetPopup, setResetPopup] = React.useState(false);
  const [taskOrActivity, setTaskOrActivity] = React.useState("");

  const resetPopupOpen = (flag) => {
    setResetPopup(true);
    setTaskOrActivity(flag);
  };
  const resetPopupClose = () => {
    setResetPopup(false);
    setTaskOrActivity(null);
  };
  const resetPersistence = async () => {
    try {
      setLoader(true);
      let req = {
        persistenceDetails: undefined,
        WorkstreamId: parseInt(props.match.params.taskId),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        "screenName": "Task"
      };
      let hidereq = {
        ColumnDetails: "[]",
        ColumnType: "TASK",
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.taskId),
      };
      Api.saveColumnSettings(hidereq);
      let response = await Api.addTaskPersistence(req);
      if (response.status == 200) {
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };

  const resetTaskActionPersistence = async () => {
    try {
      setLoader(true);
      let req = {
        persistenceDetails: undefined,
        WorkstreamId: parseInt(props.match.params.taskId),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        "screenName": "TaskAction"
      };
      let hidereq = {
        ColumnDetails: "[]",
        ColumnType: "ACTIVITY",
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.taskId),
      };
       Api.saveColumnSettings(hidereq);
      let response = await Api.addTaskPersistence(req);   
      if (response.status == 200) {
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };
  const isHiddenTaskColumn=(field)=>{
    return selectedTasksColumnFields.some((item)=>item.fieldName===field);
  }


  
  const [activitiesColumnFields,setActivitiesColumnFields]=useState([]);
  const [tasksColumnFields,setTasksColumnFields]=useState([]);
  const [selectedActivitiesColumnFields,setselectedActivitiesColumnFields]=useState([]);
  const [selectedTasksColumnFields,setselectedTasksColumnFields]=useState([]);
    const [showGrid, setShowGrid] = useState(true);
  
  const handleSelectedTasksColumnFields=(e)=>{
      setselectedTasksColumnFields(e.target.value);
      setPersistenceTaskGrid(PersistenceTasks);
      
      setShowGrid(false); // Unmount the grid
      setTimeout(() => {
        setShowGrid(true); // Remount the grid
      }, 100); 

      onColumnReorder(null);
  }

  const handleSelectedActivitiesColumnFields = (e) => {
    setselectedActivitiesColumnFields(e.target.value);
    setPersistenceTaskActionGrid(PersistenceTaskAction);

    let req = {
      persistenceDetails: undefined,
      WorkstreamId: parseInt(props.match.params.taskId),
      UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
      CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      CreatedDate: new Date(),
      updatedDate: new Date(),
      screenName: "TaskAction",
    };
    Api.addTaskPersistence(req);
  };
  
  const saveColumnSettings = async (e,flag) => {
    try {
      let req = {
        ColumnDetails: JSON.stringify(e.target.value),
        ColumnType: flag,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.taskId),
      };
      await Api.saveColumnSettings(req);
    } catch (error) {
      console.error(error);
    }
  };
  const getColumnSettings = async (flag) => {
    try {
      setLoader(true);
      let req = {
        ColumnType: flag,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.taskId),
      };
      let response = await Api.getColumnSettings(req);
      if (response.status === 200&&response.columnSettings&&response.columnSettings.columnDetails!="[]") {
        let columnDetails=JSON.parse(response.columnSettings.columnDetails);
        if (response.columnSettings.columnType === "ACTIVITY") {
          setselectedActivitiesColumnFields(columnDetails);
        } else if (response.columnSettings.columnType === "TASK") {
          setselectedTasksColumnFields(columnDetails);
        }
        setLoader(false);
      } else {
        if (flag === "ACTIVITY") {
          setselectedActivitiesColumnFields([]);
        } else if (flag === "TASK") {
          setselectedTasksColumnFields([]);
        }
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };

  const createActivityAndTaskColumns=(cfArray)=>{
    try{
      let taskCols=[];
      let activityCols=[];
      //Risk
      PersistenceTasks.map((item) => {
        if (item.field != "customFields" &&
            item.field != "isApproved" &&
            item.field != "taskTitle" &&
            item.field != "isClosed" 
          ) {
          taskCols.push({
            fieldName: item.field,
            displayName: item.title,
          });
        }
      });
      //Action
      PersistenceTaskAction.map((item) => {
        if (item.field != "customFields"&&
          item.field != "taskActionNumber"&&
          item.field != "isApproved"&&
          item.field != "taskActionTitle"&&
          item.field != "isClosed") {
          activityCols.push({
            fieldName: item.field,
            displayName: item.title,
          });
        }
      });
      cfArray.map((item)=>{
        taskCols.push({
          fieldName: item.fieldName,
          displayName: item.fieldName,
        });
      });
      taskCols.sort((a, b) => a.displayName.localeCompare(b.displayName));
      activityCols.sort((a, b) => a.displayName.localeCompare(b.displayName));
      setTasksColumnFields(taskCols);
      setActivitiesColumnFields(activityCols);
    }catch (error) {
      console.error(error);
    }
  }
  const itemRenderTask = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  const itemRenderActivity = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  const getGridColum = (columns) => {
    let field = columns.field;
    let title = columns.title;
    let width = columns.width;
    let currency = secureLocalStorage.getItem("currency");
    let effortUnitName = orgUnit?.effortUnitName;
    let isHidden=isHiddenTaskColumn(field);
    const fieldNamesSet = new Set(selectedTasksColumnFields.map(item => item.fieldName));
    if (!field) {
      return;
    } else if (field === "isApproved"&& !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          columnIndex
          cell={(props) => (
            <TaskApproved
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("isApproved")}
        />
      );
    } else if (field === "taskTitle"&& !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          reorderable={false}
          editable={true}
          locked={fixedGrid}
          fixedScroll={true}
          key={field}
          columnIndex
          cell={(props) => (
            <TaskTitle
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("taskTitle")}
        />
      );
    } else if (field === "taskDescription"&& !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDescription
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("taskDescription")}
        />
      );
    } else if (field === "cost" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(currency) ? title : title + " (" + currency + ")"
          }
          width={width}
          resizable={true}
          filter={"numeric"}
          editable={false}
          cell={(props) => (
            <TaskCost
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("cost")}
        />
      );
    }
    else if (field === "approvedCost" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(currency) ? title : title + " (" + currency + ")"
          }
          width={width}
          resizable={true}
          filter={"numeric"}
          editable={false}
          cell={(props) => (
            <TaskCost
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("approvedCost")}
        />
      );
    } else if (field === "taskActionCount" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          filter={"numeric"}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("taskActionCount")}
        />
      );
    } else if (field === "effort" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(effortUnitName)
              ? title
              : title + " (" + effortUnitName + ")"
          }
          width={width}
          resizable={true}
          filter={"numeric"}
          editable={false}
          cell={(props) => (
            <TaskEffort
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("effort")}
        />
      );
    }
    else if (field === "approvedEffort" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(effortUnitName)
              ? title
              : title + " (" + effortUnitName + ")"
          }
          width={width}
          resizable={true}
          filter={"numeric"}
          editable={false}
          cell={(props) => (
            <TaskEffort
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("approvedEffort")}
        />
      );
    } else if (field === "percentageOnTrack" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"numeric"}
          cell={(props) => (
            <TaskPercentageOnTrack
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("percentageOnTrack")}
        />
      );
    } else if (field === "percentageCompletion" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"numeric"}
          cell={(props) => (
            <TaskPercentageCompletion
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("percentageCompletion")}
        />
      );
    } else if (field === "originalCompletionDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          cell={(props) => (
            <TaskOriginalCompDate
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("originalCompletionDate")}
        />
      );
    } else if (field === "projectedCompletionDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          cell={(props) => (
            <TaskProjectedComDate
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("projectedCompletionDate")}
        />
      );
    } else if (field === "actualCompletionDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          cell={(props) => (
            <TaskActualCompDate
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              isTask={true}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("actualCompletionDate")}
        />
      );
    } else if (field === "proximityAlertDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          cell={(props) => (
            <TaskProximityAlertDate
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("proximityAlertDate")}
        />
      );
    } else if (field === "delayConsequence" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("delayConsequence")}
        />
      );
    } else if (field === "alertStakeHolders" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskAlertStakeholders
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              dropDownData={stackeHolderList}
              exitEdit={exitEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("alertStakeHolders")}
        />
      );
    } else if (field === "alertDescription" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskAlertDescription
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("alertDescription")}
        />
      );
    } else if (field === "taskOwnerName"&& !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskOwner
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              ownerList={ownerListForTask}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("taskOwnerName")}
        />
      );
    } else if (field === "priorityRankingName"&& !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <PriorityRank
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
              priorityRankingsList={priorityRankingsList}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("priorityRankingName")}
        />
      );
    } else if (field === "priorityScore"&& !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          filter={"numeric"}
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("priorityScore")}
        />
      );
    } else if (field === "createdDate"&& !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdDate")}
        />
      );
    } else if (field === "createdByName"&& !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdByName")}
        />
      );
    } else if (field === "updatedDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedDate")}
        />
      );
    } else if (field === "updatedByName" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedByName")}
        />
      );
    } else if (field === "closedDate" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("closedDate")}
        />
      );
    } else if (field === "isClosed" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskStatus
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("isClosed")}
        />
      );
    } else if (field === "progressComment" && !isHidden) {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskProgressPopup
              {...props}
              onEditCell={enterEdit}
              exitEdit={exitEdit}
              updateDropdownValue={updateTaskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("progressComment")}
        />
      );
    } else if (field === "customFields") {
      // return dropdownColumns;
      return dropdownColumns.filter(item => !fieldNamesSet.has(item.props.field));
    } else {
      let filtereddropdownColumns = dropdownColumns.filter(item => !fieldNamesSet.has(item.props.field));
      let cf = filtereddropdownColumns.find((item) => field === item.props.field);
      if (cf) {
        // Clone the object and update width
        let newCf = {
          ...cf,
          props: {
            ...cf.props,
            width: width,
          },
        };

        return newCf;
      }
    }
  };

  const exportGrid = (
    <Grid
      style={{ minHeight: "100px" }}
      data={process(data, dataState)}
      reorderable
      resizable
      pageable={true}
      sortable={true}
      onItemChange={itemChange}
      cellRender={
        workstreamRole == "Standard User" || workstreamRole == "View Only" || workstreamRole == "None"
          ? ""
          : cellRender
      }
      rowRender={rowRender}
      editField="inEdit"
      groupable={false}
      expandField="expanded"
      {...dataState}
      onDataStateChange={(e) => {
        setDataState(e.dataState);
      }}
    >
      <GridColumn
              field="taskNumber"
              title="Task Number"
              width="200px"
              
            />
            <GridColumn
              field="isApproved"
              title="Approved"
              width="200px"
              
            />
            <GridColumn
              field="taskTitle"
              title="Task Title"
              width="200px"
              
            />
            <GridColumn
              field="taskDescription"
              title="Task Description"
              width="200px"
              
            />
            <GridColumn
              field="cost"
              title={"Cost of Task" + " / "+secureLocalStorage.getItem("currency")}
              width="200px"
              
            />
            <GridColumn
              field="taskActionCount"
              title={"Activity Count"}
              width="100px"
              
            />
            <GridColumn
              field="effort"
              title={"Effort"+" (Days)"}
              filter={"numeric"}   
              width="200px"
              
            />
            <GridColumn
              field="percentageOnTrack"
              title="% on Track"
              width="200px"
              filter={"numeric"}   
              
            />
            <GridColumn
              field="percentageCompletion"
              title="% Completion"
              width="200px"
              filter={"numeric"}   
              
            />
             <GridColumn
              field="priorityRankingName"
              title="Priority Ranking"
              width="200px"
              
            />
             <GridColumn
              field="priorityScore"
              title="Priority Score"
              width="200px"
              filter={"numeric"}   
              
            />
            {/* {this.state.dropdownColumns} */}
            <GridColumn
              field="originalCompletionDate"
              title="Original Completion Date"
              width="200px"
              filter={"date"}   
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="projectedCompletionDate"
              title="Projected Completion Date"
              width="200px"
              filter={"date"}   
              format="{0:dd-MMM-yyyy}"
             
            />
            <GridColumn
              field="actualCompletionDate"
              title="Actual Completion Date"
              width="200px"
              filter={"date"}   
              format="{0:dd-MMM-yyyy}"
              
            />
            <GridColumn
              field="proximityAlertDate"
              title="Proximity Alert Date"
              width="200px"
              filter={"date"}   
              format="{0:dd-MMM-yyyy}"
              
            />
            <GridColumn
              field="delayConsequence"
              title="Delay Consequence"
              width="200px"
              
            />
            <GridColumn
              field="alertStakeHolders"
              title="Alert Stakeholders"
              width="200px"
              
            />
            <GridColumn
              field="alertDescription"
              title="Alert Description"
              width="200px"
              
            />
            <GridColumn
              field="taskOwnerName"
              title="Task Owner"
              width="200px"
              
            />
            <GridColumn
              field="createdDate"
              title="Created Date"
              width="200px"
              filter={"date"}   
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="createdByName"
              title="Created By"
              width="200px"
              
            />
            <GridColumn
              field="updatedDate"
              title="Updated Date"
              width="200px"
              filter={"date"}   
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="updatedByName"
              title="Updated By"
              width="200px"
             
            />
            <GridColumn
              field="closedDate"
              title="Closed Date"
              width="200px"
              filter={"date"}   
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="isClosed"
              title="Status"
              width="200px"
              
            />
    </Grid>
  );
  const riskGrid = (
    <Grid
      ref={gridRef}
      data={process(data, dataState)}
      reorderable={data.length == 0 ? false : true}
      resizable={data.length == 0 ? false : true}
      pageable={true}
      onItemChange={itemChange}
      cellRender={cellRender}
      rowRender={rowRender}
      editField="inEdit"
      groupable={false}
      expandField="expanded"
      filterOperators={filterOperators}
      detail={(props) => (
        <TaskActionExpandGrid
          {...props}
          getRiskRegistorList={getTasksById}
          refreshRisk={refreshTask}
          ownerListForMitigation={ownerListForTask}
          stackeHolderList={stackeHolderList}
          priorityRankingsList={priorityRankingsList}
          persistenceActionGrid={persistenceTaskActionGrid}
          selectedActivitiesColumnFields={selectedActivitiesColumnFields}
          refreshPersistence={refreshPersistence}
          customFieldsmaster={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
          organisationUnitList={[orgUnit]}
        />
      )}
      {...dataState}
      onDataStateChange={(e) => {
        setDataState(e.dataState);
      }}
      sortable={
        data.length == 0
          ? false
          : {
              allowUnsort: true,
              mode: "multiple",
            }
      }
      onFilterChange={filterChangeExisting}
      onColumnReorder={onColumnReorder}
      onColumnResize={onColumnResize}
      filter={filter}
    >
      <GridColumn
        locked={fixedGrid}
        cell={expandCell}
        width="42px"
        title=""
        minResizableWidth="42"
        resizable={false}
        reorderable={false}
      />

      {workstreamRole == "Standard User" ||
      workstreamRole == "View Only" ||
      workstreamRole == "None" ? (
        <GridColumn
          locked={fixedGrid}
          cell={actionButtonsForViewOnly}
          width="65px"
          filterable={false}
          minResizableWidth="65"
          resizable={false}
          reorderable={false}
        />
      ) : (
        <GridColumn
          locked={fixedGrid}
          cell={actionButtons}
          width="100px"
          filterable={false}
          minResizableWidth="100"
          resizable={false}
          reorderable={false}
        />
      )}
      {/* {workstreamRole == "Standard User" ||
      workstreamRole == "View Only" ||
      workstreamRole == "None" ? (
        <td></td>
      ) : (
        <GridColumn
          locked={fixedGrid}
          title="Attachments"
          cell={manageButtons}
          width="85px"
          filterable={false}
          minResizableWidth="85"
          resizable={false}
          reorderable={false}
        />
      )} */}
      <GridColumn
        locked={fixedGrid}
        field="taskNumber"
        title="Task Number"
        width="100px"
        editable={false}
        minResizableWidth="100"
        resizable={false}
        reorderable={false}
        columnMenu={(props) => (
          <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
        )}
        headerClassName={setClassName("taskNumber")}
      />

      {persistenceTaskGrid.map((columns) => getGridColum(columns))}

      <ExcelExportColumn
        field="progressHistory"
        title="Progress Status History"
        width="200px"
        cellOptions={{
          wrap: true,
          textAlign: "left",
          verticalAlign: "top",
        }}
      />
    </Grid>
  );

  const actionGrid3 = (
    <Grid style={{ display: "none" }}>
      <ExcelExportColumn
        field="organizationUnitName"
        title="Workstream"
        width="200px"
      />
       <ExcelExportColumn
        field="taskNumber"
        title="Task Number"
        width="200px"
      />
      <ExcelExportColumn
        field="taskTitle"
        title="Task Title"
        width="200px"
      />
      <ExcelExportColumn
        field="taskActionNumber"
        title="Activity Number"
        width="200px"
      />
      <ExcelExportColumn field="isApproved" title="Approved" width="200px" />
      <ExcelExportColumn
        field="taskActionTitle"
        title="Activity Title"
        width="200px"
      />
      <ExcelExportColumn
        field="taskActionDescription"
        title="Activity Description"
        width="200px"
      />
      <ExcelExportColumn
        field="cost"
        title={"Cost of Activity" + " / " + secureLocalStorage.getItem("currency")}
        width="200px"
      />
      <ExcelExportColumn field="effort" title={"Effort"} width="200px" />
      <ExcelExportColumn
        field="percentageOnTrack"
        title="% on Track"
        width="200px"
      />
      <ExcelExportColumn
        field="percentageCompletion"
        title="% Completion"
        width="200px"
      />
      <ExcelExportColumn
        field="priorityRankingName"
        title="Priority Ranking"
        width="200px"
      />

      <ExcelExportColumn
        field="originalCompletionDate"
        title="Original Completion Date"
        width="200px"
      />
      <ExcelExportColumn
        field="projectedCompletionDate"
        title="Projected Completion Date"
        width="200px"
      />
      <ExcelExportColumn
        field="actualCompletionDate"
        title="Actual Completion Date"
        width="200px"
      />
      <ExcelExportColumn
        field="proximityAlertDate"
        title="Proximity Alert Date"
        width="200px"
      />
      <ExcelExportColumn
        field="delayConsequence"
        title="Delay Consequence"
        width="200px"
      />
      <ExcelExportColumn
        field="alertStakeHolders"
        title="Alert Stakeholders"
        width="200px"
      />
      <ExcelExportColumn
        field="alertDescription"
        title="Alert Description"
        width="200px"
      />
      <ExcelExportColumn
        field="ownerName"
        title="Activity Owner"
        width="200px"
      />
      <ExcelExportColumn
        field="createdDate"
        title="Created Date"
        width="200px"
      />
      <ExcelExportColumn
        field="createdByName"
        title="Created By"
        width="200px"
      />
      <ExcelExportColumn
        field="updatedDate"
        title="Updated Date"
        width="200px"
        filter={"date"}
      />
      <ExcelExportColumn
        field="updatedByName"
        title="Updated By"
        width="200px"
      />
      <ExcelExportColumn
        field="closedDate"
        title="Closed Date"
        width="200px"
        filter={"date"}
      />
      <ExcelExportColumn field="isClosed" title="Status" width="200px" />

      <ExcelExportColumn field="departments" title="Departments" width="150px" />
      <ExcelExportColumn field="externalStatus" title="External Status" width="120px" />
      <ExcelExportColumn field="weeklyReport" title="Weekly Report" width="100px" />

      <ExcelExportColumn
        field="progressHistory"
        title="Progress Status History"
        width="200px"
        resizable={true}
        reorderable={true}
        editable={true}
        cellOptions={{
          wrap: true,
          textAlign: "left",
          verticalAlign: "top",
        }}
      />
    </Grid>
  );

  let gridPDFExport;

  const exportPDF = () => {
    setLoader(true);
    var filteredData = filterBy(data, filter);
    gridPDFExport.save(filteredData);
    pdfTitlePopupClose();
    setLoader(false);
    setTitle("");
  };

  const pdfTitlePopupClose = () => {
    setOpenPdfTitlePopup(false);
  };
  const pdfTitlePopupOpen = () => {
    setOpenPdfTitlePopup(true);
  };

  const getSelectedColumn = (col) => {
    if (col != selectedColumn) {
      selectedColumn = col;
    }
  };

  const [copyTaskAndActivityFlag, setCopyTaskAndActivityFlag] = useState(false);
  const closeCopyRiskAndActionPopup = () => {
    setCopyTaskAndActivityFlag(false);
  };
  const openCopyRiskAndActionPopup = () => {
    setCopyTaskAndActivityFlag(true);
  };
  
  const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
  return (
    <div className="riskDashboardCont">
      {loader ? (
        <span className="MatTableSpinner">
          <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
        </span>
      ) : null}

      {/* Task Form View */}
      <TaskRegisterFormView
        formEditFlag={formEditFlag}
        formData={formData}
        showFormView={showFormView}
        orgUnit={orgUnit}
        closeRiskFormView={closeRiskFormView}
        addRiskDataFromForm={addRiskDataFromForm}
        dropDownData={stackeHolderList}
        ownerListForRisk={ownerListForTask}
        priorityRankingsList={priorityRankingsList}
        selectedTasksColumnFields={selectedTasksColumnFields}
        customFieldsData={
          customFieldsData.length > 0 ? customFieldsData : customFieldsDataState
        }
        {...props}
        ref={myRef}
      />
      {/* copy risk and action  */}

      <CopyTaskAndActivity
        copyRiskAndActionFlag={copyTaskAndActivityFlag}
        closeCopyRiskAndActionPopup={closeCopyRiskAndActionPopup}
        orgUnitId={props.match.params.taskId}
        getRiskRegistorList={refreshTask}
      />

      <div className="riskDashboard sidebarOpened">
        {/* Excel Import Dialog */}
        {isvalidatepopup === false && (
          <Popup show={excelImport} popupClass={"popup-content"}>
            <div className="importriskpoup">
              {loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
              <div className="importheader">
                <h3>
                  {isTaskImport ? "Task Import File" : "Activity Import File"}
                </h3>
              </div>
              {pendingCommitFlag === true ? (
                <div className="importheader">
                  <h3>Pending Commit already exist.</h3>
                  <div className="btnCont">
                    <div className="action_btn">
                      <button
                        className="validate_btn_pending"
                        onClick={enable_validatepopup}
                      >
                        Validate
                      </button>
                      <div onClick={closepopup} className="Cancel__btn">
                        Cancel
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="selecttemplate">
                  <label style={{ color: "#ffffff" }}>Select Template: </label>
                  <DropDownList
                    data={
                      isTaskImport
                        ? excelTemplates.filter(
                            (item) => item.templateType === "task"
                          )
                        : excelTemplates.filter(
                            (item) => item.templateType === "taskaction"
                          )
                    }
                    onChange={(e) => setExcelTemplatesValue(e.target.value)}
                    style={{ width: "100%" }}
                    textField="templateName"
                    value={excelTemplateValue}
                    id="templateId"
                  />
                  {excelTemplateValue ? (
                    <div
                      className="exportDialogCont"
                      style={{
                        padding: "0px",
                        minHeight: "70px ",
                        width: "100% ",
                        marginTop: "12px",
                      }}
                    >
                      <div className="uploadSec" style={{ height: "80px " }}>
                        <div
                          className="innerBorder"
                          style={{ height: "60px ", maxHeight: "60px " }}
                        >
                          <p>
                            {isTaskImport
                              ? "Upload Your Task File"
                              : "Upload Your Activity File"}
                          </p>
                          <span>
                            {importFileName
                              ? importFileName
                              : "File should be in .xlsx format"}
                          </span>
                          <input
                            type="file"
                            accept=".xlsx"
                            onChange={handleUpload}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="btnCont">
                    <div className="action_btn">
                      {validateBtnFlag && (
                        <button
                          className="validate_btn"
                          onClick={enable_validatepopup}
                        >
                          Validate
                        </button>
                      )}
                      <button
                        onClick={
                          isTaskImport
                            ? saveTaskDataUploadFile
                            : saveActivityDataUploadFile
                        }
                        className="Submit__btn"
                        disabled={
                          (importFileName
                            ? false
                            : true ||
                              excelTemplateValue === "undefined" ||
                              excelTemplateValue === "null") ||
                          enable_errorlog === true ||
                          validateBtnFlag
                        }
                      >
                        Submit
                      </button>
                      <div onClick={closepopup} className="Cancel__btn">
                        Cancel
                      </div>
                    </div>

                    {enable_errorlog === true && (
                      <div>
                        <div className="btnCont">
                          <div
                            className="action_btn"
                            style={{ justifyContent: "flex-start" }}
                          >
                            <ul className="Rowcount">
                              <li>
                                <span>
                                  Total Rows:{dataUploadCount.totalRow}
                                </span>
                              </li>
                              <li>
                                <span>Failed:{dataUploadCount.failedRow}</span>
                              </li>
                              <li>
                                <span>Passed:{dataUploadCount.successRow}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="errorlog" id="myInput">
                          <span className="errordownload">
                            <ul title="Error log download">
                              <a>
                                <img
                                  src={Images.DOWNLOAD}
                                  alt="Download"
                                  width="16px"
                                  onClick={downloadErrorLogFile}
                                />
                              </a>
                            </ul>
                          </span>
                          <PDFExport
                            paperSize="A4"
                            margin="2cm"
                            ref={pdfExportComponent}
                          >
                            <Errorlogtreeview>
                              {renderSubtrees(errorDataList)}
                            </Errorlogtreeview>

                            {/* <Treebeard data={errorDataList} onToggle={onToggle} /> */}
                          </PDFExport>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </Popup>
        )}
        {isvalidatepopup === true && (
          <Window
            // title={isRiskImport ? "Risks" : "Actions"}
            onClose={cancelvalidate}
            className="excelvalidation"
            initialLeft={100}
            initialTop={50}
            initialWidth={1200}
            initialHeight={1200}
          >
            <div className="validateriskpopup">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="validate_header" style={{ marginLeft: "10px" }}>
                  {isTaskImport === true ? "Tasks" : "Activities"}{" "}
                </div>
              </div>
              <div className="btnCont">
                <div
                  className="action_btn"
                  style={{ justifyContent: "flex-start", marginTop: "5px" }}
                >
                  <ul className="Rowcount">
                    <li>
                      <span
                        style={
                          taskValidationDataCount.newTaskCount === 0
                            ? { fontWeight: "normal", fontSize: "12px" }
                            : {
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "rgb(181 61 202)",
                                padding: "5px",
                                borderRadius: "5px",
                              }
                        }
                      >
                        Total Created Records:{" "}
                        {taskValidationDataCount.newTaskCount
                          ? taskValidationDataCount.newTaskCount
                          : 0}
                      </span>
                    </li>
                    <li>
                      <span
                        style={
                          taskValidationDataCount.modifiedTaskCount === 0
                            ? { fontWeight: "normal", fontSize: "12px" }
                            : {
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "#3cb34d",
                                padding: "5px",
                                borderRadius: "5px",
                              }
                        }
                      >
                        Total Updated Records:{" "}
                        {taskValidationDataCount.modifiedTaskCount
                          ? taskValidationDataCount.modifiedTaskCount
                          : 0}
                      </span>
                    </li>
                    <li>
                      <span
                        style={
                          taskValidationDataCount.closedTaskCount === 0
                            ? { fontWeight: "normal", fontSize: "12px" }
                            : {
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "#428fed",
                                padding: "5px",
                                borderRadius: "5px",
                              }
                        }
                      >
                        Total Closed Records:{" "}
                        {taskValidationDataCount.closedTaskCount
                          ? taskValidationDataCount.closedTaskCount
                          : 0}
                      </span>
                    </li>
                    {isTaskImport === true ? (
                      <li>
                        <span
                          style={
                            taskValidationDataCount.aggregateCellsCount === 0
                              ? { fontWeight: "normal", fontSize: "12px" }
                              : {
                                  fontWeight: "bold",
                                  fontSize: "15px",
                                  color: "#ea8211e3",
                                  padding: "5px",
                                  borderRadius: "5px",
                                }
                          }
                        >
                          Unchanged Aggregate Cells:{" "}
                          {taskValidationDataCount.aggregateCellsCount
                            ? taskValidationDataCount.aggregateCellsCount
                            : 0}
                        </span>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                </div>
              </div>
              {isTaskImport === true ? (
                <div className="tblCont dataGrids" id="validategrid">
                  <ValidateTasks
                    workstreamId={parseInt(props.match.params.taskId)}
                    orgUnit={orgUnit}
                    riskData={data}
                    handleValidateDataCount={handleValidateDataCount}
                    loader={loader}
                    customFieldsmaster={
                      customFieldsData.length > 0
                        ? customFieldsData
                        : customFieldsDataState
                    }
                  ></ValidateTasks>
                </div>
              ) : (
                <div className="tblCont dataGrids" id="validategrid">
                  <ValidateActivity
                    workstreamId={parseInt(props.match.params.taskId)}
                    orgUnit={orgUnit}
                    handleValidateDataCount={handleValidateDataCount}
                    customFieldsmaster={
                      customFieldsData.length > 0
                        ? customFieldsData
                        : customFieldsDataState
                    }
                    loader={loader}
                  ></ValidateActivity>
                </div>
              )}

              <div className="btnCont">
                <div className="action_btn">
                  <button
                    className="Submit__btn"
                    onClick={() => commitTasks("commit")}
                    id="validatesubmit"
                  >
                    Commit
                  </button>
                  <button
                    className="validate_cancelbtn"
                    style={{ marginTop: "0px" }}
                    onClick={() => commitTasks("uncommit")}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Window>
        )}

        <div className="mainWrapper">
          <div className="dashboardCont RiskConts RiskListContainer">
            <h2>{orgUnit.unitName}</h2>
            <div className="dbGrids">
              <div className="dbRow">
                <div className="dbCol rBox">
                  <div className="gBox">
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.ASSESSMENT}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Total Tasks</p>
                        <h4>
                          {taskMetrics.totalTasksCount
                            ? taskMetrics.totalTasksCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <div className="dbConfigData">
                        <p>Open Tasks</p>
                        <h4>
                          {taskMetrics.openTasksCount
                            ? taskMetrics.openTasksCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Closed Tasks</p>
                        <h4>
                          {taskMetrics.closedTasksCount
                            ? taskMetrics.closedTasksCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.ASSESSMENT}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Total Activities</p>
                        <h4>
                          {taskActionMetrics.totalTaskActionCount
                            ? taskActionMetrics.totalTaskActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <div className="dbConfigData">
                        <p>Open Activities</p>
                        <h4>
                          {taskActionMetrics.openTaskActionCount
                            ? taskActionMetrics.openTaskActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CLOSEDRISK}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Closed Activities</p>
                        <h4>
                          {taskActionMetrics.closedTaskActionCount
                            ? taskActionMetrics.closedTaskActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>
                    {/* New Keys*/}
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.UNAPPROVE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Total  Activities  Cost</p>
                        <h4>
                          {secureLocalStorage.getItem("currency")}
                          {taskActionMetrics.totalTaskActionCost
                            ? formatNumber(
                                taskActionMetrics.totalTaskActionCost,
                                "##,#"
                              )
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Approved  Activities  Cost</p>

                        <h4>
                          {secureLocalStorage.getItem("currency")}
                          {taskActionMetrics.approvedTaskActionCost
                            ? formatNumber(
                                taskActionMetrics.approvedTaskActionCost,
                                "##,#"
                              )
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.DASHBOARDICON}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Unapproved  Activities  Effort</p>
                        <h4>
                          {taskActionMetrics.unApprovedTaskActionEffort
                            ? taskActionMetrics.unApprovedTaskActionEffort
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.DASHBOARDICON}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Approved  Activities  Effort</p>
                        <h4>
                          {taskActionMetrics.approvedTaskActionEffort
                            ? taskActionMetrics.approvedTaskActionEffort
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.VIEWDATA}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Original  Overdue Activities</p>
                        <h4>
                          {taskActionMetrics.overdueTaskActionCount
                            ? taskActionMetrics.overdueTaskActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.VIEWDATA}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Projected Overdue Activities</p>
                        <h4>
                          {taskActionMetrics.projectedOverdueTaskActionCount
                            ? taskActionMetrics.projectedOverdueTaskActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>
                    {/* End  */}
                    <div className="d-flex rskBtn">
                      <ul>
                        <li
                          onClick={exportPDF}
                          title="Export Risks PDF"
                        >
                          <a>
                            <img src={Images.PDF} alt="Export PDF" width="16" />
                          </a>
                        </li>
                        <li onClick={exportExcel} title="Export Excel">
                          <a>
                            <img
                              src={Images.XLSX}
                              alt="Export Task Excel"
                              width="20"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="rw-tab-cont">
              <div className="d-flex">
                <ul className="rw-nav rw-nav-tabs">
                  <li className="rw-nav-item">
                    <a className="rw-nav-link active">Tasks ({data.length})</a>
                  </li>
                  <span
                    style={{
                      color: "#ffffff",
                      fontSize: "12px",
                      paddingTop: "6px",
                    }}
                  >
                    {"Hide Activity Columns"}&nbsp;
                  </span>
                  <li className="rw-nav-item">
                    <div className="showhidecols">
                      <MultiSelect
                        // placeholder="Hide Action Columns"
                        onChange={(e) => handleSelectedActivitiesColumnFields(e)}
                        onClose={(e) => saveColumnSettings(e, "ACTIVITY")}
                        value={selectedActivitiesColumnFields}
                        data={activitiesColumnFields}
                        itemRender={itemRenderActivity}
                        valueField="fieldName"
                        textField="displayName"
                        dataItemKey="fieldName"
                        filterable={false}
                        autoClose={false}
                        tags={
                          selectedActivitiesColumnFields.length > 0
                            ? [
                                {
                                  text: `${selectedActivitiesColumnFields.length} Activity columns are hidden`,
                                  data: [...selectedActivitiesColumnFields],
                                },
                              ]
                            : []
                        }
                      />
                    </div>
                  </li>
                  <span
                    style={{
                      color: "#ffffff",
                      fontSize: "12px",
                      paddingTop: "6px",
                    }}
                  >
                    {"Hide Task Columns"}&nbsp;
                  </span>
                  <li className="rw-nav-item">
                    <div className="showhidecols">
                      <MultiSelect
                        // placeholder="Hide Risk Columns"
                        onChange={(e) => handleSelectedTasksColumnFields(e)}
                        onClose={(e) => saveColumnSettings(e, "TASK")}
                        value={selectedTasksColumnFields}
                        data={tasksColumnFields}
                        itemRender={itemRenderTask}
                        valueField="fieldName"
                        textField="displayName"
                        dataItemKey="fieldName"
                        filterable={false}
                        autoClose={false}
                        tags={
                          selectedTasksColumnFields.length > 0
                            ? [
                                {
                                  text: `${selectedTasksColumnFields.length} Task columns are hidden`,
                                  data: [...selectedTasksColumnFields],
                                },
                              ]
                            : []
                        }
                      />
                    </div>
                  </li>
                </ul>
                <div className="ml-auto d-flex">
                  <button
                    className="addRisks"
                    onClick={() => resetPopupOpen("ACTIVITY")}
                  >
                    Reset Activity
                  </button>
                  <button
                    className="addRisks"
                    onClick={() => resetPopupOpen("TASK")}
                  >
                    Reset Task
                  </button>

                  {workstreamRole == "Standard User" ||
                  workstreamRole == "View Only" ||
                  workstreamRole == "None" ? (
                    ""
                  ) : (
                    <div>
                      <button
                        className="addRisks"
                        onClick={openCopyRiskAndActionPopup}
                      >
                        Copy Tasks/Activities
                      </button>
                      <button
                        className="addRisks"
                        onClick={() => handleOpenExportDialog(true)}
                      >
                        Import Task
                      </button>
                      <button
                        className="addRisks"
                        onClick={() => handleOpenExportDialog(false)}
                      >
                        Import Activity
                      </button>
                    </div>
                  )}

                  {workstreamRole == "Standard User" ||
                  workstreamRole == "View Only" ||
                  workstreamRole == "None" ? (
                    ""
                  ) : (
                    <button className="addRisks" onClick={openTaskFormView}>
                      Add Task
                    </button>
                  )}
                </div>
              </div>

              <div className="rw-tab-content" id="rw-tab-header">
                <div className="rw-tab-pane  active" id="risk-register">
                  <div
                    className="tblCont taskRegisters dataGrids riskRegTable riskDataGrid"
                    id="DataGrid"
                  >
                    <>
                      {/* <ExcelExport data={data}>{riskGrid}
                      </ExcelExport> */}
                      {showGrid ? (
                        <ExcelExport
                          data={data}
                          fileName={
                            orgUnit.unitName
                              ? orgUnit.unitName.replace(".", " ")
                              : "Tasks" + ".xlsx"
                          }
                          ref={_exporter}
                          headerPaddingCellOptions={{
                            background: "#ff0000",
                          }}
                        >
                          {riskGrid}
                        </ExcelExport>
                      ) : (
                        <p className="refreshGrid">
                          Refreshing grid, please wait...
                        </p>
                      )}

                      <ExcelExport
                        data={action}
                        fileName={
                          orgUnit.unitName
                            ? orgUnit.unitName.replace(".", " ")
                            : "Activities" + ".xlsx"
                        }
                        ref={_exporterAction}
                        headerPaddingCellOptions={{
                          background: "#ff0000",
                        }}
                      >
                        {actionGrid3}
                      </ExcelExport>
                    </>

                    <GridPDFExport
                      ref={(pdfExport) => (gridPDFExport = pdfExport)}
                      fileName={
                        orgUnit.unitName
                          ? orgUnit.unitName.replace(".", " ")
                          : "Tasks" + ".pdf"
                      }
                      margin="1cm"
                      date={new Date()}
                      // paperSize={["1000mm", "400mm"]}
                      paperSize={"auto"}
                      title={title + " " + CreatedDate}
                      repeatHeaders={true}
                    >
                      {exportGrid}
                    </GridPDFExport>
                  </div>
                </div>
                <div className="rw-tab-pane  fade">
                  {/* Oppertunities Container  */}
                </div>
                <div className="rw-tab-pane  fade">
                  {/* Elivated Container  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup show={openDeleteModelFlag} popupClass={"popup-content"}>
        {loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div className="deleteModelCont">
          <h3>
            {taskActionCount > 0
              ? "Activities associated with this Task, Are you sure you want to delete this Task?"
              : "Are you sure you want to delete this Task?"}
          </h3>
          <div className="btnCont">
            <button onClick={() => deleteTask()} className="deleteBtn">
              Delete
            </button>
            <button onClick={deleteRiskPopupClose} className="cancelBtn">
              Cancel
            </button>
          </div>
        </div>
      </Popup>

      <Popup show={openPdfTitlePopup} popupClass={"popup-content"}>
        {loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        <div className="addTypeForm">
          <div className="fieldCont">
            <label>Enter Title</label>
            <input
              type="text"
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Title"
              value={title}
              required
            />
          </div>
          <div className="btnGroup">
            <button
              disabled={!title}
              className="btnPrimary"
              onClick={exportPDF}
            >
              Export
            </button>
            <button className="btnDark" onClick={pdfTitlePopupClose}>
              Cancel
            </button>
          </div>
        </div>
      </Popup>

      <Popup show={resetPopup} popupClass={"popup-content"}>
        {loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div className="deleteModelCont">
          <h3>
            {taskOrActivity === "TASK"
              ? "Are you sure that you want to reset the Task to its default settings?"
              : "Are you sure that you want to reset the Activity to its default settings?"}
          </h3>
          <div className="btnCont">
            <button
              onClick={() =>
                taskOrActivity === "TASK"
                  ? resetPersistence()
                  : resetTaskActionPersistence()
              }
              className="deleteBtn"
            >
              Reset
            </button>
            <button onClick={resetPopupClose} className="cancelBtn">
              Cancel
            </button>
          </div>
        </div>
      </Popup>
    </div>
  );
}
